import './application'
import App from 'src/faq/pages/index.vue'
import router from 'src/faq/routes'
import store from 'src/faq/store'
import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import VueRouter from 'vue-router'
import VueThinModal from 'vue-thin-modal'
import Vuex from 'vuex'

Vue.use(InfiniteLoading)
Vue.use(VueRouter)
Vue.use(VueThinModal)
Vue.use(Vuex)

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    el: '#faq',
    router,
    store,
    render: h => h(App)
  })
})
